import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import essay2609Thumbnail from "../image/articles/essay260901.webp";
import image1 from "../image/articles/essay260801.webp";
import image2 from "../image/articles/essay260802.webp";
import image3 from "../image/articles/essay260803.webp";
import image4 from "../image/articles/essay260804.webp";
import image5 from "../image/articles/essay260805.webp";
import image6 from "../image/articles/essay260806.webp";
import image7 from "../image/articles/essay260807.webp";
import image8 from "../image/articles/essay260808.webp";
import image9 from "../image/articles/essay260809.webp";
import image10 from "../image/articles/essay260810.webp";
import image11 from "../image/articles/essay260811.webp";
import image12 from "../image/articles/essay260812.webp";
import image13 from "../image/articles/essay260813.webp";
import image14 from "../image/articles/essay260814.webp";
import image15 from "../image/articles/essay260815.webp";


function Essay2609(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const images1 = [image2, image3,  image4, image5, ];
    const images2 = [image6, image7, image15];
    const images3 = [image8, image9, image10];
    const images4 = [image11, image12, image13, image14, ];
    
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '삶을 재미있게 살아가는 원칙 - Lynkim',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'삶을 재미있게 살아가는 원칙'}
                titleEn={'26.09. Review'}
                category={'essay'}
                date={'2026.10.09.'}
                thumbnail={image1}

            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection
                title = '짧은 생각들'
                titleEn = 'Snippets'
                marginBottom={true}
                description={<div>
                    <b>(1)</b> 여수로 여행을 갔다. 여수 여행을 가기까지 생각이 이리저리 바뀌어서, 정말로 가는 게 맞을지 고민이 많이 됐다. 결국 떠나오긴 했는데, 같은 가격이면 베트남에서 호캉스를 즐겨도 될 만큼 숙소비가 비싸서 망설여졌다. 그런데 막상 부담 없이 타고 가는 기차여행이 여독 없이 힐링을 주었다. <br/>
여수에서 둘째 날부터는 폭우가 쏟아졌는데, 일에서 벗어난 상태라 그런지 비가 오는 것조차 기분이 좋았다. 신발 안에 물이 차오르는데도, 쏟아지는 폭우를 뚫고 밖을 돌아다니는 게 왜 이렇게 기분이 좋은지 모르겠다.<br/>
돌이켜보면 고민이 되었던 건, 혹시나 스트레스로 인해 충동적으로 돈을 쓰는 게 되면 어쩌나 하는 마음이 들어서였던 것 같다. 그래도 올해 여름을 아무 곳도 가지 않고 사무실에만 앉아 있지 않을 수 있었던 건 참 다행이다.

<br/><br/><b>(2)</b> 아주 오랜만에 피겨 스케이팅을 타러 아이스링크를 찾아갔다. 이번에는 혼자서가 아닌 남자친구와 함께 갔는데, 혼자가 아닌 다른 누군가와 함께 스케이트를 타러 간 것은 정말 생애 처음이었다. 오랜만에 가서 연습을 하려고 한 것도 있지만, 내 취미를 공유하고 싶은 마음도 있었다. 내가 좋아하는 취미를 보여주고 싶은 것도 있었고, 내가 좋아하는 것을 함께 즐겨 주기를 기대하기도 했다. 나는 내 삶을 함께 즐겨 주는 게 너무나 큰 행복이다. 항상 거부하지 않고 흥미를 갖고 즐겨 줘서 너무 고맙다. <br/>
스케이트를 타며 누군가를 가르쳐 준 적이 한 번도 없었는데, 이건 또 너무 신선한 경험이었다. 너무나 당연하게, 이번 1시간 안에 앞으로, 뒤로, 코너링도 할 수 있게 만들 수 있다고 생각했던 내 스스로가 얼마나 다른 사람에 대한 이해가 낮았는지 깨달았다. 짧은 시간이었지만, 나는 인상 깊고 재미있게 기억에 남았다고 알아주었으면 좋겠다.
                    
                    </div>}
                descriptionEn={<div>
                  <b>(1)</b> I took a trip to Yeosu. My mind kept shifting back and forth right up until I left, so I worried a lot about whether going was really the right choice. I ended up coming anyway, though I hesitated at first because the accommodation cost was high enough that I could have just gone to Vietnam for a *ho-cance* (hotel vacation) for the same price. But surprisingly, taking a stress-free train ride gave me a deep sense of healing without any travel fatigue. <br/>
It started pouring rain on the second day in Yeosu, but since I was completely disconnected from work, even the rain felt nice. Water was soaking into my shoes, but for some reason, wandering through the heavy downpour felt so liberating.<br/>
Looking back, I think my hesitation came from a lingering worry that I might impulsively spend money due to stress. Still, I’m so glad I didn't spend this summer cooped up in an office and actually went somewhere.

<br/><br/><b>(2)</b> I went to the ice rink for a game of figure skating for the very first time in ages. This time, I went with my boyfriend rather than alone—it was literally my first time ever going ice skating with someone else. Part of me wanted to get some practice in after so long, but I also wanted to share my hobby with him. I wanted to show him something I love, and honestly, I hoped he would enjoy it with me too. Bringing someone along to share in my life brings me immense happiness. Thank you so much for always jumping in without hesitation and having fun with it. <br/>
I had never taught anyone how to skate before, and that in itself was such a fresh experience. It made me realize how low my understanding of others was, assuming so naively that I could teach someone to skate forward, backward, and corner within just an hour. It was a short time, but I really hope he remembers it as deeply meaningful and fun.
                     </div>}
                   />

                <ArticleImageLayout 
                 images={images2}
                />
                <ArticleTextSection
                marginTop={true}
                marginBottom={true}
                description={<div>
                    <b>(3)</b> 놀란 감독의 새 영화 오디세이가 나왔다. 놀란 감독의 상상력을 볼 수 있는 SF 영화를 좋아하는데, 이번에는 기존의 오디세이아를 놀란 감독의 해석으로 그려낸 영화였다. 항상 놀란 감독의 영화를 보면 참 잘 만들었다, 사람들의 감정을 어떻게 울릴 수 있는지 잘 아는 감독인 것 같다는 생각을 한다. 그러면서도 영화가 느끼하지 않다. <br/>
내 세계관 속으로 사람들을 끌어들이는 일을 하고 싶다는 생각을 많이 한다. 그래서 보드게임을 만들고 싶기도 하고 소설을 써 보고 싶기도 하다. 언젠가는 꼭 하나쯤 작품을 남기고, 세상에 이런 생각을 하는 사람이 있다 정도의 존재감은 남기고 싶다.
                    <br/><br/><b>(4)</b> 올해 가장 기억에 남는 일을 꼽으라면, 단연 그토록 보고 싶었던 맨체스터 시티의 경기를 실제로 관람했던 일을 꼽을 것 같다. 축구 경기 보는 것을 꽤 좋아하는데, 올해 쿠팡플레이가 주최하는 친선경기를 우연한 기회에 무료로 관람할 수 있게 되었다. 함께 일하는 PM님이 쿠팡플레이에서 일한 적이 있어서 무료 관람권을 주셨는데, 무려 50만 원짜리 프리미엄 좌석권이었다. 살면서 또 언제 이런 경험을 할 수 있을까 하는 생각이 들기까지 했다.<br/>
함께 관람한 예슬 님도 수줍음 없이 경기를 함께 즐겨주어 더 좋았고, 1:0으로 지고 있었지만 너무나 멋진 경기력으로 3:1 역전승을 거두어 더욱 재미있었다. 경기 결과보다도 은은하게 더운 공간에서 땀 흘리며 시원한 맥주를 눈치 보지 않고 마시며 기분 좋게 취한 채 경기를 관람한 것도 큰 역할을 한 것 같다.<br/>축구 경기를 실제로 본 건 10년 내 손에 꼽는 기억 중 하나로 남을 것 같다.
                    </div>}
                descriptionEn={<div>
                  <b>(3)</b> Christopher Nolan's new film, *Odyssey*, has finally been released. I love sci-fi films that showcase Nolan's boundless imagination, and this time, he reinterpreted the classic *Odyssey* through his own unique lens. Whenever I watch his movies, I always think about how brilliantly crafted they are and how well he understands how to move people's emotions. Yet somehow, the films never feel overly sentimental. <br/>
I often find myself wanting to draw people into my own worldview. That’s why I sometimes want to design board games or write a novel. Someday, I definitely want to leave behind at least one piece of work—just enough of a presence to show the world that someone with thoughts like these existed.

<br/><br/><b>(4)</b> If someone asked me what my most memorable moment of the year was, I’d undoubtedly say it was getting to watch a Manchester City match live. I really love watching football, and thanks to a chance opportunity, I was able to attend a friendly hosted by Coupang Play for free. A PM I work with used to work at Coupang Play, so they managed to get me a free ticket—and not just any ticket, but a 500,000-won premium seat. It even made me wonder if I'd ever experience anything like this again in my life. <br/>
It was even better because Yeseul, who came with me, enjoyed the game together without any shyness. Even though they were down 1:0, their incredible performance leading to a 3:1 comeback win made it so much fun. More than the final score, sitting in the gently warm air, sweating, drinking ice-cold beer without a care, and watching the game with a pleasant buzz played a huge part in making it special. <br/>
Seeing a football match live will definitely go down as one of my most cherished memories of the past ten years.
                     </div>}
                   />
                <ArticleImageLayout 
                 images={images3}
                />
                
                <ArticleImageLayout 
                 images={images4}
                />

        <NextItem to='/Essay2609' thumbnail={essay2609Thumbnail} nextProjectTitle='26.09. 회고'/>

        <BackButton/>
        </div>
        </ProtectedPage>
        </>
      )
  }

export default Essay2609;